import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28154661&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=28154661&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=28154661&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28154661",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28154661')) {
      api.createRecord('28154661', component.options)
    } else {
      api.reload('28154661', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28154661&scoped=true&", function () {
      api.rerender('28154661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/zhlg/index.vue"
export default component.exports